Ext.define('SA.EditModelObserver', {
    statics: {
        create(model, callback, scope) {
            return new SA.EditModelObserver(model, callback, scope);
        }
    },

    constructor(model, callback, scope) {
        this.model = model;
        this.observable = new Ext.util.Observable();

        this.callback = callback.bind(scope);
        this.maybeCallback = this.maybeCallback.bind(this);

        this.observable.mon(model, 'remove', () => this.observable.destroy());
    },

    maybeCallback() {
        if (this.enabled) {
            Ext.callback(this.callback);
        }
    },

    observeAttributes() {
        var queueCoalescedCallback = SA.CoalescingMicroTask.coalesce(this.maybeCallback);

        this.observable.mon(this.model, 'change:attribute', queueCoalescedCallback);
        this.observable.mon(this.model.getProject(), 'change:attribute', queueCoalescedCallback);
    },

    observeBusinesses() {
        var queueCoalescedCallback = SA.CoalescingMicroTask.coalesce(this.maybeCallback);

        this.observable.mon(this.model, 'change:businessSearch', queueCoalescedCallback);
        this.observable.mon(this.model.getProject(), 'change:businessSearch', queueCoalescedCallback);
    },

    observeLocations() {
        SA.EditModelLocationsObserver.observe({observable: this.observable, model: this.model, callback: this.maybeCallback});
    },

    observeName() {
        this.observable.mon(this.model, 'change:name', this.maybeCallback);
    },

    setEnabled(enabled) {
        this.enabled = enabled;
    }
});